import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { MapPin, ArrowRight } from "lucide-react";

const roleHome = { warehouse_agent: "/warehouse", front_desk_agent: "/frontdesk", supervisor: "/supervisor", company_admin: "/admin", platform_admin: "/admin" };

export default function StoreSelect() {
  const { user, stores, setCurrentStore } = useAuth();
  const navigate = useNavigate();

  const pick = (s) => {
    setCurrentStore(s);
    navigate(roleHome[user.role] || "/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-3xl">
        <h1 className="font-display text-5xl font-extrabold tracking-tight mb-2">Select your store</h1>
        <p className="text-muted-foreground mb-8">Choose the location you are working at today.</p>
        <div className="grid sm:grid-cols-2 gap-4">
          {stores.map((s) => (
            <button key={s.id} onClick={() => pick(s)} data-testid={`store-option-${s.store_code}`}
              className="group text-left bg-card border border-border p-6 hover:border-white transition-colors duration-200">
              <div className="flex items-center justify-between">
                <span className="font-mono-t text-sm text-muted-foreground">{s.store_code}</span>
                <ArrowRight size={18} className="text-muted-foreground group-hover:text-white transition-colors" />
              </div>
              <div className="font-display text-2xl font-bold mt-2">{s.store_name}</div>
              <div className="text-sm text-muted-foreground flex items-center gap-1 mt-1">
                <MapPin size={13} /> {s.town}, {s.parish}
              </div>
              {!s.is_active && <div className="text-xs text-alert-amber mt-2 uppercase tracking-wide">Inactive</div>}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
